import { httpBatchLink, httpLink, TRPCClientError } from "@trpc/client"
import { createTRPCReact } from "@trpc/react-query"
import { getCookie } from "react-use-cookie"

import trpcTransformer from "@forento/core/utilities/trpcTransformer"

import { connectionFetch } from "~/utilities/connectivity"

import type { AppRoutes } from "../../../api/src/routes"

export const query = createTRPCReact<AppRoutes>({ abortOnUnmount: true })

const url = getCookie("apiUrl", CONFIG.apiUrl)

/**
 * @deprecated Use the query hook instead
 * @see query
 */
const trpc = query.createClient({
	links: [
		CONFIG.isDevelopment
			? httpLink({ url, transformer: trpcTransformer, fetch: connectionFetch })
			: httpBatchLink({
					url,
					transformer: trpcTransformer,
					fetch: (url, options) => connectionFetch(url, { ...options, credentials: "include" }),
				}),
	],
})

/**
 * For calls that have to outlive the page, such as the closing activity heartbeat sent while the tab is
 * being torn down. Unbatched so each request stays inside the size limit `keepalive` imposes.
 */
export const keepaliveTrpc = query.createClient({
	links: [
		httpLink({
			url,
			transformer: trpcTransformer,
			fetch: (url, options) =>
				fetch(url, {
					...options,
					...(CONFIG.isDevelopment ? {} : { credentials: "include" }),
					keepalive: true,
				}),
		}),
	],
})

function isTRPCClientError(cause: unknown): cause is TRPCClientError<AppRoutes> {
	return cause instanceof TRPCClientError
}

export function getInputErrors(error: unknown): Record<string, string[]> {
	if (!isTRPCClientError(error)) return {}
	return error.data?.inputErrors ?? {}
}

export default trpc
